import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  className?: string;
  truncate?: boolean;
  children: ReactNode;
};

export const PanelHeadline = (props: Props) => {
  const { children, truncate, className } = props;
  return <Headline className={cx('headline', className, { truncate })}>{children}</Headline>;
};

const Headline = styled.h3`
  margin-top: 0;
  font-weight: 100;
  font-size: 1.65rem;
  margin-bottom: 10px;
  white-space: pre-wrap;

  &.truncate {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    min-height: 26px;
  }

  a,
  a:active,
  a:not(.btn):hover,
  a:visited {
    font-weight: 100;
    text-decoration: none;
    font-size: 1.6rem;
  }
`;
